export const arrayConditionnalElement = (element, condition) => {
  if (condition) {
    if (Array.isArray(element)) {
      return element;
    }
    return [element];
  }

  return [];
};
